import { VegaButton, VegaFont, VegaPageNotification } from '@globalpayments/vega-react';

import DetailsModal from '../../../components/detailsModal';
import { UserSummary } from '../../../types/users';

interface ResendLoginLinkDialogProps {
  error?: Error | null;
  isPending: boolean;
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  user?: UserSummary;
}

/** Confirms sending a replacement login link to an existing user. */
const ResendLoginLinkDialog = ({ error, isPending, onClose, onSubmit, open, user }: ResendLoginLinkDialogProps) => (
  <DetailsModal
    backdrop="static"
    footerActions={
      <VegaButton
        disabled={!user || isPending}
        label={isPending ? 'Sending login link' : 'Send login link'}
        onVegaClick={onSubmit}
      />
    }
    modalTitle="Resend login link"
    onClose={onClose}
    open={open}>
    {error && (
      <VegaPageNotification duration={0} message={error.message} notificationTitle="Resend failed" type="error" />
    )}
    <VegaFont as="p">
      Send a new login link to {user?.email}? They receive an email with a new sign-in link that expires on its own.
    </VegaFont>
  </DetailsModal>
);

export default ResendLoginLinkDialog;
